import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.PayWithAmax.BankAccountInfo', {
    bankName: 'Bank name',
    bankAccountName: 'Account name',
    balance: 'Balance',
    accountNumber: 'Account number',
    sortCode: 'Sort code',
});
